module.exports = __webpack_public_path__ + "static/media/right__arrow.6fef8b72.svg";